import { useMemo } from "react";

import FormField from "ds/components/Form/Field";
import Link from "ds/components/Link";
import Typography from "ds/components/Typography";
import useTypedContext from "hooks/useTypedContext";
import SharedModulesTierInfo from "components/TierInfo/SharedModulesTierInfo";

import { ModuleSettingsContext } from "../Context";
import ModuleSettingsPageLayout from "../components/PageLayout";
import ModuleSettingsFormWrapper from "../components/FormWrapper";

const ModuleSettingsSharingViewForm = () => {
  const { module } = useTypedContext(ModuleSettingsContext);

  const sharedSpaces = useMemo(() => {
    return module.moduleShares
      .filter((share) => share.to.space?.id && share.to.space?.name)
      .map((space) => ({
        id: space.to.space?.id,
        name: space.to.space?.name,
      }));
  }, [module.moduleShares]);

  return (
    <ModuleSettingsPageLayout
      title="Availability"
      description="Your module is automatically available in its origin space and all descendants. Expand availability to other spaces as needed."
    >
      <SharedModulesTierInfo type="callout" />
      <ModuleSettingsFormWrapper>
        <FormField label="Spaces">
          {sharedSpaces.length === 0 && (
            <Typography tag="p" variant="p-body2" color="disabled">
              No spaces
            </Typography>
          )}
          {sharedSpaces.map((space) => (
            <Typography key={space.id} tag="p">
              <Link href={`/spaces/${space.id}`}>{space.name}</Link>
            </Typography>
          ))}
        </FormField>
      </ModuleSettingsFormWrapper>
    </ModuleSettingsPageLayout>
  );
};

export default ModuleSettingsSharingViewForm;
